var viewport = require('responsive-toolkit');

var visibilityDivs = {
    'xs': $('<div class="hidden-sm-up"></div>'),
    'sm': $('<div class="hidden-xs-down hidden-md-up"></div>'),
    'md': $('<div class="hidden-sm-down hidden-lg-up"></div>'),
    'lg': $('<div class="hidden-md-down hidden-xl-up"></div>'),
    'xl': $('<div class="hidden-lg-down"></div>')
};

viewport.use('Custom', visibilityDivs);

module.exports = viewport;


//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/utils/responsive-bootstrap-toolkit/responsive-bootstrap-toolkit.js
// module id = 7
// module chunks = 36